<form [formGroup]="formGroup" class="sldc">
  @for (element of elements; track element; let i = $index) {
    @if (element.type === "radiogroup") {
      <div class="sldc-row">
        <div class="sldc-q">
          <div class="sldc-q-title">
            <span>{{ i }}. {{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="sldc-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="sldc-a">
          <div class="sldc-group">
            @for (choice of element.choices; track choice.value) {
              <label class="sldc-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="sldc-option-text">{{
                  choice.text | translate
                }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
  }

</form>
